const API_URL = process.env.VUE_APP_API_URL;
const API_V1 = `${API_URL}/v1`;
const BACKEND_URL = process.env.VUE_APP_BACKEND_URL;
const BACKEND_V1 = `${BACKEND_URL}/v1`;

const BASE_URL = Object.freeze({
  APPROVAL_STATE: `${BACKEND_V1}/approval_state`,
  BANK: `${API_V1}/bank`,
  COURSES: `${BACKEND_V1}/courses`,
  EKYC: `${BACKEND_V1}/ekyc`,
  FILE: `${BACKEND_V1}/files`,
  INDIVIDUAL: `${BACKEND_V1}/individual`,
  PERMISSIONS: `${BACKEND_V1}/permissions`,
  ROLE: `${BACKEND_V1}/role`,
  ROLES: `${BACKEND_V1}/roles`,
  SAR: `${BACKEND_V1}/sar`,
  TRANSACTION: `${BACKEND_V1}/transaction`,
  USER: `${API_V1}/users`,
  USERS: `${BACKEND_V1}/users`,
  YOUTUBE: 'https://www.youtube.com',
});

export default Object.freeze({
  BACKEND_URL,
  BASE_URL,
});
